import {Component, OnInit} from '@angular/core';
import {StdManagementService} from './std-management.service';
import {DepartmentsModel} from './models/departments.model';
import {PositionsModel} from './models/positions.model';
import {UsersModel} from './models/users.model';
import {RemoveUserComponent} from './modals/remove-user/remove-user.component';
import {AssignStandardsComponent} from './modals/assign-standards/assign-standards.component';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {NotifierService} from 'angular-notifier';

@Component({
  selector: 'app-standards-management',
  templateUrl: './standards-management.component.html',
  styleUrls: ['./standards-management.component.css']
})
export class StandardsManagementComponent implements OnInit {

  errorLoading = false;

  usersLoaded = false;
  departmentsLoaded = false;
  positionsLoaded = false;

  leftColumnStandardsLoaded = false;
  leftColumnPersonalStandardsLoaded = false;

  departments: DepartmentsModel;
  departmentsRightColumn: DepartmentsModel;
  positions: PositionsModel;
  positionsRightColumn: PositionsModel;
  users: UsersModel;
  standardsLeftColumn = [];
  personalStandardsLeftColumn = [];
  selectedStandardsLeftColumn = [];
  selectedStandardsRightColumn = [];
  selectedPersonalStandardsLeftColumn = [];
  inactiveByPositionsStandards = [];
  selectedInactiveByPositionStandards = [];

  standardsRightColumn = [];


  selectedDepartment = {
    id: '',
    name: 'Select Department'
  };
  selectedPosition = {
    id: '',
    name: 'Select Position'
  };
  selectedUser = {
    id: '',
    fullName: 'Select User'
  };

  selectedDepartmentRightColumn = {
    id: '',
    name: 'Select Department'
  };

  selectedPositionRightColumn = {
    id: '',
    name: 'Select Position'
  };

  numberInput = '';
  nameInput = '';

  searchTextDepartmentsLeft;
  searchTextPositionsLeft;
  searchTextUsers;
  searchTextDepartmentsRight;
  searchTextPositionsRight;

  private readonly notifier: NotifierService;

  constructor(private stdManagementService: StdManagementService,
              private modalService: NgbModal,
              notifierService: NotifierService) {
    this.notifier = notifierService;
  }

  ngOnInit() {
    this.searchUser();
    this.searchGroup();
    this.searchGroupRight();
    this.searchPositions();
    this.searchPositionsRightColumn();
    this.searchStandardsWithName();

  }

  // API Requests

  searchUser() {
    const params = {
      searchField: '',
      searchOperation: '',
      searchValue: '',
      groupId: '',
      positionId: ''
    };

    if (this.selectedDepartment.id.length > 0) {
      params.groupId = this.selectedDepartment.id;
    }

    if (this.selectedPosition.id.length > 0) {
      params.positionId = this.selectedPosition.id;
    }

    this.stdManagementService.searchManagementUser(params.searchField, params.searchOperation, params.searchValue, params.groupId, params.positionId).subscribe(
      (response: any) => {
        this.users = response.body;
        this.usersLoaded = true;
      },
      () => {
        this.errorLoading = true;
      });
  }

  searchGroup() {
    const params = {
      searchField: '',
      searchOperation: '',
      searchValue: '',
      positionId: '',
      userId: ''
    };

    if (this.selectedPosition.id.length > 0) {
      params.positionId = this.selectedPosition.id;
    }

    if (this.selectedUser.id.length > 0) {
      params.userId = this.selectedUser.id;
    }

    this.stdManagementService.searchManagementGroup(params.searchField, params.searchOperation, params.searchValue, params.positionId, params.userId).subscribe(
      (response: any) => {
        this.departments = response.body;
        this.departmentsLoaded = true;
      },
      () => {
        this.errorLoading = true;
      });
  }

  searchPositions() {
    const params = {
      searchField: '',
      searchOperation: '',
      searchValue: '',
      groupId: '',
      userId: ''
    };

    if (this.selectedDepartment.id.length > 0) {
      params.groupId = this.selectedDepartment.id;
    }

    if (this.selectedUser.id.length > 0) {
      params.userId = this.selectedUser.id;
    }

    this.stdManagementService.searchManagementPositions(params.searchField, params.searchOperation, params.searchValue, params.groupId, params.userId).subscribe(
      (response: any) => {
        this.positions = response.body;
        this.positionsLoaded = true;
      },
      () => {
        this.errorLoading = true;
      });
  }

  searchStandardsWithUser() {
    const params = {
      groupId: '',
      positionId: '',
      userId: ''
    };

    if (this.selectedDepartment.id !== '') {
      params.groupId = this.selectedDepartment.id;
    }

    if (this.selectedPosition.id !== '') {
      params.positionId = this.selectedPosition.id;
    }

    if (this.selectedUser.id !== '') {
      params.userId = this.selectedUser.id;
    }

    this.stdManagementService.searchStandardsWithUser(params.groupId, params.positionId, params.userId).subscribe(
      (response: any) => {
        this.standardsLeftColumn = response.body;
        this.leftColumnStandardsLoaded = true;
      },
      () => {
        this.errorLoading = true;
      });
  }

  searchPersonalStandards() {
    const params = {
      groupId: '',
      positionId: '',
      userId: ''
    };

    if (this.selectedDepartment.id !== '') {
      params.groupId = this.selectedDepartment.id;
    }

    if (this.selectedPosition.id !== '') {
      params.positionId = this.selectedPosition.id;
    }

    if (this.selectedUser.id !== '') {
      params.userId = this.selectedUser.id;
    }

    this.stdManagementService.searchPersonalStandards(params.groupId, params.positionId, params.userId).subscribe(
      (response: any) => {
        this.personalStandardsLeftColumn = response.body;
        this.leftColumnPersonalStandardsLoaded = true;
      },
      () => {
        this.errorLoading = true;
      });
  }

  searchInactiveByPosition() {
    const params = {
      groupId: '',
      positionId: '',
      userId: ''
    };

    if (this.selectedDepartment.id !== '') {
      params.groupId = this.selectedDepartment.id;
    }

    if (this.selectedPosition.id !== '') {
      params.positionId = this.selectedPosition.id;
    }

    if (this.selectedUser.id !== '') {
      params.userId = this.selectedUser.id;
    }

    this.stdManagementService.searchStandardsWithoutUserOnPosition(params.groupId, params.positionId, params.userId).subscribe(
      (response: any) => {
        this.inactiveByPositionsStandards = response.body;
      },
      () => {
        this.errorLoading = true;
      });
  }

  searchStandardsWithName() {
    this.selectedStandardsRightColumn = [];
    const params = {
      groupId: '',
      positionId: '',
      number: '',
      name: ''
    };

    if (this.selectedDepartmentRightColumn.id.length > 0) {
      params.groupId = this.selectedDepartmentRightColumn.id;
    }

    if (this.selectedPositionRightColumn.id.length > 0) {
      params.positionId = this.selectedPositionRightColumn.id;
    }

    if (this.nameInput.trim() !== '') {
      params.name = this.nameInput.trim();
    }

    if (this.numberInput.trim() !== '') {
      params.number = this.numberInput.trim();
    }

    this.stdManagementService.searchStandardsWithName(params.groupId, params.positionId, params.number, params.name).subscribe(
      (response: any) => {
        this.standardsRightColumn = response.body;
      },
      () => {
        this.errorLoading = true;
      });
  }

  // Remove standards from list
  removeStandards() {
    const reqBody = {
      standards: this.selectedStandardsLeftColumn,
      groupId: '',
      positionId: '',
      userId: ''
    };

    if (this.selectedPersonalStandardsLeftColumn.length > 1) {
      this.selectedPersonalStandardsLeftColumn.forEach(standard => {
        reqBody.standards.push(standard);
      });
      reqBody.standards = reqBody.standards.filter((x, i, a) => a.indexOf(x) === i);
    }

    if (this.selectedStandardsLeftColumn.length < 1 && this.selectedPersonalStandardsLeftColumn.length > 0) {
      reqBody.standards = this.selectedPersonalStandardsLeftColumn;
    }

    if (this.selectedDepartment.id !== '') {
      reqBody.groupId = this.selectedDepartment.id;
    }

    if (this.selectedPosition.id !== '') {
      reqBody.positionId = this.selectedPosition.id;
    }

    if (this.selectedUser.id !== '') {
      reqBody.userId = this.selectedUser.id;
    }

    this.stdManagementService.removeUsersFromStandards(reqBody.standards, reqBody.groupId, reqBody.positionId, reqBody.userId).subscribe(
      () => {
        this.clearSelectedStandards();
        this.clearSelectedPersonalStandards();
        this.searchStandardsWithUser(); // Invoke this function to update left standards column with selected groupId, positionId and userId after unassign
        if (this.selectedUser.id.length > 1) {
          this.searchPersonalStandards();
        }
        if (this.selectedPosition.id.length > 0 && this.selectedUser.id.length > 0) {
          this.selectedInactiveByPositionStandards = [];
          this.searchInactiveByPosition();
        }
        this.notifier.notify('success', 'Unassign successful!');
      },
      () => {
        this.notifier.notify('error', 'Unassign finished with error.');
      });
  }

  // Assign standards
  assignStandards() {
    const reqBody = {
      standards: this.selectedStandardsRightColumn,
      groupId: '',
      positionId: '',
      userId: ''
    };

    if (this.selectedInactiveByPositionStandards.length > 1) {
      this.selectedInactiveByPositionStandards.forEach(standard => {
        reqBody.standards.push(standard);
      });
      reqBody.standards = reqBody.standards.filter((x, i, a) => a.indexOf(x) === i);
    }

    if (this.selectedStandardsRightColumn.length < 1 && this.selectedInactiveByPositionStandards.length > 0) {
      reqBody.standards = this.selectedInactiveByPositionStandards;
    }

    if (this.selectedDepartment.id !== '') {
      reqBody.groupId = this.selectedDepartment.id;
    }

    if (this.selectedPosition.id !== '') {
      reqBody.positionId = this.selectedPosition.id;
    }

    if (this.selectedUser.id !== '') {
      reqBody.userId = this.selectedUser.id;
    }

    reqBody.standards.forEach(std => {
    });

    this.stdManagementService.assignStandards(reqBody.standards, reqBody.groupId, reqBody.positionId, reqBody.userId).subscribe(
      () => {
        this.clearSelectedStandards();
        this.clearSelectedPersonalStandards();
        this.clearSelectedStandardsRightColumn();
        this.clearInactiveByPositionStandards();
        this.searchStandardsWithUser(); // Invoke this function to update left standards column with selected groupId, positionId and userId after unassign
        if (this.selectedUser.id.length > 1) {
          this.searchPersonalStandards();
        }
        if (this.selectedPosition.id.length > 0 && this.selectedUser.id.length > 0) {
          this.searchInactiveByPosition();
        }
        this.notifier.notify('success', 'Assign successful!');
      },
      () => {
        this.notifier.notify('error', 'Assign finished with error.');
      });
  }

  // Left Departments Dropdown

  selectDepartment(department) {
    this.selectedDepartment.id = department.id;
    this.selectedDepartment.name = department.name;

    if (this.selectedPosition.id.length > 0 && this.selectedUser.id.length > 0) {
      this.searchInactiveByPosition();
    }

    this.searchPositions();
    this.searchUser();
    this.clearSelectedStandards();
    this.clearSelectedPersonalStandards();
    this.searchStandardsWithUser();
  }

  // Left Positions Dropdown

  selectPosition(position) {
    this.selectedPosition.id = position.id;
    this.selectedPosition.name = position.name;
    this.clearSelectedStandards();
    this.clearSelectedPersonalStandards();

    if (this.selectedDepartment.id.length < 1) {
      this.searchGroup();
    }

    if (this.selectedUser.id.length > 0) {
      this.searchInactiveByPosition();
    }

    this.searchUser();
    this.searchStandardsWithUser();
  }

  // Left Users Dropdown

  selectUser(user) {
    this.selectedUser.id = user.id;
    this.selectedUser.fullName = user.fullName;
    this.clearSelectedStandards();
    this.clearSelectedPersonalStandards();
    this.searchPersonalStandards();
    if (this.selectedDepartment.id.length < 1) {
      this.searchGroup();
    }
    if (this.selectedPosition.id.length < 1) {
      this.searchPositions();
    }
    this.searchPositions();
    if (this.selectedDepartment.id.length > 0 || this.selectedPosition.id.length > 0) {
      this.searchStandardsWithUser();
    }

    if (this.selectedPosition.id.length > 0) {
      this.searchInactiveByPosition();
    }
  }

  clearAllLeftColumn() {
    this.selectedDepartment.id = '';
    this.selectedDepartment.name = 'Select Department';
    this.selectedPosition.id = '';
    this.selectedPosition.name = 'Select Position';
    this.selectedUser.id = '';
    this.selectedUser.fullName = 'Select User';
    this.selectedInactiveByPositionStandards = [];
    this.inactiveByPositionsStandards = [];
    this.clearSelectedStandards();
    this.clearSelectedPersonalStandards();
    this.searchGroup();
    this.searchPositions();
    this.searchUser();
  }

  // Left Standards List
  appendStandard(standardId) {

    if (this.selectedStandardsLeftColumn.includes(standardId)) {
      const index: number = this.selectedStandardsLeftColumn.indexOf(standardId);
      if (index !== -1) {
        this.selectedStandardsLeftColumn.splice(index, 1);
      }
    } else {
      this.selectedStandardsLeftColumn.push(standardId);
    }
  }

  appendPersonalStandard(standardId) {

    if (this.selectedPersonalStandardsLeftColumn.includes(standardId)) {
      const index: number = this.selectedPersonalStandardsLeftColumn.indexOf(standardId);
      if (index !== -1) {
        this.selectedPersonalStandardsLeftColumn.splice(index, 1);
      }
    } else {
      this.selectedPersonalStandardsLeftColumn.push(standardId);
    }
  }

  appendRightStandard(standardId) {

    if (this.selectedStandardsRightColumn.includes(standardId)) {
      const index: number = this.selectedStandardsRightColumn.indexOf(standardId);
      if (index !== -1) {
        this.selectedStandardsRightColumn.splice(index, 1);
      }
    } else {
      this.selectedStandardsRightColumn.push(standardId);
    }
  }

  appendInactiveStandard(standardId) {

    if (this.selectedInactiveByPositionStandards.includes(standardId)) {
      const index: number = this.selectedInactiveByPositionStandards.indexOf(standardId);
      if (index !== -1) {
        this.selectedInactiveByPositionStandards.splice(index, 1);
      }
    } else {
      this.selectedInactiveByPositionStandards.push(standardId);
    }
  }

  clearSelectedStandards() {
    this.selectedStandardsLeftColumn = [];
  }

  clearSelectedPersonalStandards() {
    this.selectedPersonalStandardsLeftColumn = [];
  }

  clearSelectedStandardsRightColumn() {
    this.selectedStandardsRightColumn = [];
  }

  clearInactiveByPositionStandards() {
    this.selectedInactiveByPositionStandards = [];
  }

  isSelectedStandard(standardId) {
    return this.selectedStandardsLeftColumn.includes(standardId);
  }

  isSelectedPersonalStandard(standardId) {
    return this.selectedPersonalStandardsLeftColumn.includes(standardId);
  }

  isSelectedAllStandards(standardId) {
    return this.selectedStandardsRightColumn.includes(standardId);
  }

  isSelectedInactiveStandard(standardId) {
    return this.selectedInactiveByPositionStandards.includes(standardId);
  }

  // Arrows

  // Unassign standards modal window alert
  openUnassignModal() {
    const modalRef = this.modalService.open(RemoveUserComponent);
    modalRef.result.then((result) => {
      if (result === 'Yes') {
        this.removeStandards();
      }
    });
  }

  // Assign standards modal window alert
  openAssignModal() {
    const modalRef = this.modalService.open(AssignStandardsComponent);
    modalRef.result.then((result) => {
      if (result === 'Yes') {
        this.assignStandards();
      }
    });
  }

  // Right Departments Dropdown
  selectDepartmentRightColumn(department) {
    this.selectedDepartmentRightColumn.id = department.id;
    this.selectedDepartmentRightColumn.name = department.name;
    this.selectedPositionRightColumn.id = '';
    this.selectedPositionRightColumn.name = 'Select Position';
    this.searchPositionsRightColumn();
  }

  selectPositionRightColumn(position) {
    this.selectedPositionRightColumn.id = position.id;
    this.selectedPositionRightColumn.name = position.name;
    if (this.selectedDepartmentRightColumn.id.length < 1) {
      this.searchGroupRight();
    }
  }

  searchGroupRight() {
    const params = {
      searchField: '',
      searchOperation: '',
      searchValue: '',
      positionId: '',
      userId: ''
    };

    if (this.selectedPositionRightColumn.id.length > 0) {
      params.positionId = this.selectedPositionRightColumn.id;
    }

    this.stdManagementService.searchManagementGroup(params.searchField, params.searchOperation, params.searchValue, params.positionId, params.userId).subscribe(
      (response: any) => {
        this.departmentsRightColumn = response.body;
      },
      () => {
        this.errorLoading = true;
      });
  }

  searchPositionsRightColumn() {
    const params = {
      searchField: '',
      searchOperation: '',
      searchValue: '',
      groupId: '',
      userId: ''
    };

    if (this.selectedDepartmentRightColumn.id.length > 0) {
      params.groupId = this.selectedDepartmentRightColumn.id;
    }

    this.stdManagementService.searchManagementPositions(params.searchField, params.searchOperation, params.searchValue, params.groupId, params.userId).subscribe(
      (response: any) => {
        this.positionsRightColumn = response.body;
        this.positionsLoaded = true;
      },
      () => {
        this.errorLoading = true;
      });
  }

  clearAllRightColumn() {
    this.selectedDepartmentRightColumn.id = '';
    this.selectedDepartmentRightColumn.name = 'Select Department';
    this.selectedPositionRightColumn.id = '';
    this.selectedPositionRightColumn.name = 'Select Position';
    this.nameInput = '';
    this.numberInput = '';
    this.selectedStandardsRightColumn = [];
    this.searchGroupRight();
    this.searchPositionsRightColumn();
    this.searchStandardsWithName();
  }

  /*
 MISC

   Sorting array by values A-Z
*/
  sortList(prop, list) {
    if (list !== undefined) {
      return list.sort((a, b) => a[prop].toLowerCase() > b[prop].toLowerCase() ? 1 : a[prop].toLowerCase() === b[prop].toLowerCase() ? 0 : -1);
    }
  }

  loaded() {
    return this.usersLoaded && this.positionsLoaded && this.departments && !this.errorLoading;
  }

  disabledUnassignButton() {
    if ((this.selectedStandardsLeftColumn.length < 1 && this.selectedPersonalStandardsLeftColumn.length < 1) ||
      this.selectedStandardsLeftColumn.length > 0 && this.selectedDepartment.id.length < 1 && this.selectedUser.id.length < 1) {
      return true;
    }
  }

  disabledAssignButton() {
    if ((this.selectedDepartment.id.length < 1 && this.selectedPosition.id.length < 1 && this.selectedUser.id.length < 1) ||
      this.selectedStandardsRightColumn.length < 1 && this.selectedInactiveByPositionStandards.length < 1) {
      return true;
    }
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/standards-management/standards-management.component.ts